import { NOTIFICATION_TYPE_LABEL, TNotificationType } from "@/features/dashboard/constants/notificationTab";
import { TagNew } from "@/modules/irohana-components/elements/TagNew";
import { blue, text } from "@/theme/colors";
import { FC } from "react";

type Props = {
  type: TNotificationType;
};

export const NotificationTag: FC<Props> = ({ type }) => (
  <TagNew
    variant="regular"
    color={blue[60]}
    textColor={text.white}
    title={NOTIFICATION_TYPE_LABEL[type]}
    fontWeight={500}
    size="medium"
    sx={{ minWidth: "102px" }}
  />
);
